import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import './tabs_switcher.scss';

const TabsSwitcher = ({ options, active, onClick }) => (
  <div className="tabs-switcher">
    {_.map(options, option => (
      <button
        key={`tab-switcher-${option.value}`}
        className={classnames('tabs-switcher__option', 'caption', {
          'tabs-switcher__option--active': option.value === active,
        })}
        onClick={() => onClick(option.value)}
        type="button"
      >
        {option.label}
      </button>
    ))}
  </div>
);

TabsSwitcher.propTypes = {
  active: PropTypes.string,
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

export default TabsSwitcher;
